// Shared tooltip look for the recharts charts on the dashboard
const ChartTooltip = ({
  active,
  payload,
  label,
  format = (v: number) => v.toLocaleString(),
}: {
  active?: boolean;
  payload?: any[];
  label?: string;
  format?: (v: number) => string;
}) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-hcBorder bg-white px-3 py-2 text-xs shadow-pop">
      {label && <p className="mb-1 font-semibold text-honeConnectBlack">{label}</p>}
      {payload.map((p) => (
        <p key={p.dataKey} className="flex items-center gap-2 text-honeConnectGray">
          <span className="h-2 w-2 rounded-full" style={{ background: p.color || p.fill }} />
          <span className="capitalize">{p.name}</span>
          <span className="ml-auto pl-3 font-semibold text-honeConnectBlack">
            {format(Number(p.value))}
          </span>
        </p>
      ))}
    </div>
  );
};

export default ChartTooltip;
